import Link from "./Link";
import Meta from "./Meta";
import TagList from "./TagList";
import Title from "./Title";
import VariantList from "./VariantList";
import Thumbnail from "./Thumbnail";

export default {
  Link,
  Meta,
  TagList,
  Title,
  VariantList,
  Thumbnail
};
